var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCrossIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.01953 1.5L18.0195 17.5L2.01953 1.5Z",
    fill: "#283333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.01953 1.5L18.0195 17.5",
    stroke: "#283333",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0195 1.5L2.01953 17.5L18.0195 1.5Z",
    fill: "#283333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0195 1.5L2.01953 17.5",
    stroke: "#283333",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCrossIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAyMCAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yLjAxOTUzIDEuNUwxOC4wMTk1IDE3LjVMMi4wMTk1MyAxLjVaIiBmaWxsPSIjMjgzMzMzIi8+CjxwYXRoIGQ9Ik0yLjAxOTUzIDEuNUwxOC4wMTk1IDE3LjUiIHN0cm9rZT0iIzI4MzMzMyIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTguMDE5NSAxLjVMMi4wMTk1MyAxNy41TDE4LjAxOTUgMS41WiIgZmlsbD0iIzI4MzMzMyIvPgo8cGF0aCBkPSJNMTguMDE5NSAxLjVMMi4wMTk1MyAxNy41IiBzdHJva2U9IiMyODMzMzMiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPgo8L3N2Zz4K";